import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { SpecialAccountRequest, DeleteSpecialAccountRequest } from '../models/request';
import { SpecialAccountsResponse } from '../models/response/specialAccountsResponse';


const baseRoute: string = 'SpecialAccount';

export class SpecialAccountApi {
  saveScpecialAccount(request: SpecialAccountRequest): Promise<AxiosResponse<Result<any[]>>> {
    return api.post(`${baseRoute}/save`, request);
  }

  getSpecialAccount(guidInsurer: string): Promise<AxiosResponse<Result<SpecialAccountsResponse[]>>> {
    return api.get(`${baseRoute}`, { params: { guidInsurer } });
  }

  deleteSpecialAccount(request: DeleteSpecialAccountRequest): Promise<AxiosResponse> {
    return api.post(`${baseRoute}/inactivespecialaccount`, request);
  }
}